<template>
    <div class='ToCash'>
        <ApplyNoalert ref='ApplyNoalert'/>
        <el-form :inline="true" :model="formInline" class="demo-form-inline selectForm">
            <el-form-item label="项目名称：">
                <el-input v-model="formInline.user" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table
            height="520"
            class="applyTable"
            ref="multipleTable"
            :data="tableDataAll"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              prop="name"
              label="项目名称"
              align="left"
              width="400"
            >
                <template slot-scope="scope">
                    <p><span style="padding-right: 20px;">{{scope.row.time}}</span><span>编号：2120004000003</span></p>
                    <p>{{scope.row.name}}</p>
                    <p><i class="el-icon-document-copy"></i><span>招商引资</span></p>
                </template>
            </el-table-column>
            <el-table-column
              prop="money"
              label="金额"
              align="center"
            >
                <template slot-scope="scope">
                    <p><i class="el-icon-question"></i>申报：￥{{scope.row.money}}</p>
                    <p>支持|单位</p>
                </template>
            </el-table-column>
            <el-table-column
              prop="statu"
              label="全部状态"
              align="center"
            >
                <template slot-scope="scope">
                    <p class="statuColor applying" v-if="scope.row.statu==1">审核中</p>
                    <p>项目详情</p>
                </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="155">
                <template slot-scope="scope">
                    <p><i class="el-icon-timer"></i>已审2小时</p>
                    <p>拷贝项目</p>
                </template>
            </el-table-column>
        </el-table>
        <div class="applyPagination">
            <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="0">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import ApplyNoalert from '@/components/ApplyNo_alert.vue'
    export default {
        name: "ToCash",
        components:{
            ApplyNoalert
        },
        data() {
            return {
                formInline: {
                    user: '',
                    region: ''
                },
                value1: '',
                currentPage: 1,
               tableDataAll:[
                ],
            };
        },
        methods: {
            onSubmit(){
                
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            look() {
                this.$router.push({
                    name: "ApplyNo_det",
                });
            },
            appeal() {
                this.$refs.ApplyNoalert.show({
                    type:1
                })
            },
            upload() {
                this.$refs.ApplyNoalert.show({
                    type:2
                })
            },
            download(){

            },
            // 分页
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            }
        }
    };
</script>
<style lang='scss' scoped>
.ToCash{
    .applyTab{
        border-top: 2px solid #E4E7ED;
        /deep/.el-tabs__item{
            padding: 0 20px;
            font-size: 16px;
            height: 50px;
            line-height: 50px;
            color: rgba(56, 56, 56, 1);
        }
        /deep/.selectForm{
            .el-form-item{
                margin-right: 5%;
            }
            .el-date-editor .el-range-separator{
                width: 10%;
            }
        }
    } 
    .applyTable{
        /deep/.has-gutter tr th{
            background-color: rgba(250, 250, 250, 1);
        }
        .statuColor::before{
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin-right: 5px;
        }
        .applying::before{
            background-color:rgba(24, 144, 255, 1);
        }
        .applypass::before{
            background-color:rgba(67, 207, 124, 1);
        }
        .applyreject::before{
            background-color:rgba(245, 34, 45, 1);
        }
        .uploaddata::before{
            background-color:rgb(25, 207, 231);
        }
        .tocash::before{
            background-color:rgba(255, 141, 26, 1);
        }
        .givrup::before{
            background-color:rgba(0, 0, 0, 0.25);
        }
    }
    .applyPagination{
        text-align: right;
        margin-top: 10px;
    }
}

</style>